import React, { FunctionComponent, Fragment, useMemo } from "react";
import { Link, useTheme } from "@material-ui/core";
import { CircleColorIcon } from "../../../assets/icons/circle-color-icon";

const REFERENCE_REGEX = /\(\d{1,2}\.?\)/gm; // Gets (1) and (1.) -- up to 99

interface ILinkToReferenceProps {
  reference: string;
}
const LinkToReference: FunctionComponent<ILinkToReferenceProps> = ({ reference }) => {
  const theme = useTheme();
  const textToShow = reference.replaceAll(/\(|\)|\./gm, ""); // Remove parentheses and dots.
  return (
    <Link href={`#${textToShow}`} key={textToShow}>
      <CircleColorIcon color={theme.palette.primary.main} darkenOnHover>
        {textToShow}
      </CircleColorIcon>
    </Link>
  );
};

interface ITextWithReferencesProps {
  text: string;
}
export const TextWithReferences: FunctionComponent<ITextWithReferencesProps> = (props) => {
  const { text } = props;

  const refsInText = useMemo(() => {
    const matches = text.match(REFERENCE_REGEX);
    return matches || [];
  }, [text]);

  const textSplitOnRefs = useMemo(() => {
    return text.split(REFERENCE_REGEX);
  }, [text]);

  return (
    <Fragment>
      {textSplitOnRefs.map((textChunk, idx) => {
        const reference = idx > 0 && refsInText.length >= idx ? refsInText[idx - 1] : null;
        return (
          <span key={idx}>
            {reference && (
              <>
                {" "}
                <LinkToReference reference={reference} />{" "}
              </>
            )}
            {textChunk}
          </span>
        );
      })}
    </Fragment>
  );
};
